import React, { useContext } from "react";
import ShopCartStyle from "./ShopCartStyle.module.css";
import { Link } from "react-router-dom";
//import context
import { CartContext } from "../context/CartContextProvider";
//import components
import Cart from "./Cart";
import { ButtonError, Button } from "../components/UI/Button";

//start functions
const ShopCart = () => {
  const { state, dispatch } = useContext(CartContext);

  return (
    <>
      <div className={ShopCartStyle.container}>
        {state.selectedItems.map((item) => (
          <Cart key={item.id} data={item} />
        ))}
      </div>
      {state.itemsCounter > 0 && (
        <div className={ShopCartStyle.checkout}>
          <div className={ShopCartStyle.Pcontainer}>
            {" "}
            <p>
              <span style={{ color: "black" }}> دوره ها:</span>
              <span style={{ color: "#f9f9f9",marginRight:'2px'  }}>{state.itemsCounter}</span>
            </p>
            <p>
              <span style={{ color: "black" }}>قیمت:</span>
              <span style={{ color: "#f9f9f9",marginRight:'2px' }}>{state.total}تومان</span>
            </p>
          </div>
          <div className={ShopCartStyle.btnContainer}>
            <Button onClick={() => dispatch({ type: "CHECKOUT" })}>
              پرداخت
            </Button>
            <ButtonError onClick={() => dispatch({ type: "CLEAR" })}>
              پاک کردن
            </ButtonError>
          </div>
        </div>
      )}
      {state.checkout && (
        <div className={ShopCartStyle.empityCart}>
          <span>پرداخت با موفقیت انجام شد!</span>
          <Link to="/">برای خرید بیشتر کلیک کنید</Link>
        </div>
      )}
      {!state.checkout && state.itemsCounter === 0 && (
        <div className={ShopCartStyle.empityCart}>
          <h3>تمایل به خرید دارید؟</h3>
          <p>
            <Link to="/">بریم برا بازدید</Link>
          </p>
        </div>
      )}
    </>
  );
};

export default ShopCart;
